import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';

import { type ConfirmDialogProps } from './types';
import { useTranslate } from 'src/locales';
import { Box, Alert, Stack, Typography } from '@mui/material';

// ----------------------------------------------------------------------

export function ConfirmDialog({
  open,
  title,
  action,
  content,
  onClose,
  type,
  belowContent,
  ...other
}: ConfirmDialogProps) {
  const { t } = useTranslate();

  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose} {...other}>
      <Stack direction="row" sx={{ m: 2 }} data-test-id="confirm-dialog">
        {!!type && (
          <Box sx={{ width: 55, mr: 2 }}>
            <Alert severity={type} />
          </Box>
        )}

        <Box>
          {typeof title === 'string' ? <Typography variant="subtitle1">{title}</Typography> : title}

          {typeof content === 'string' ? (
            <Typography variant="body2">{content}</Typography>
          ) : (
            content
          )}
        </Box>
      </Stack>

      {belowContent && <Box sx={{ mx: 2, mb: 2 }}>{belowContent}</Box>}

      <DialogActions>
        <Button
          data-test-id="close-btn"
          variant={!action ? 'soft' : 'outlined'}
          color={(!!type && !action && type) || 'inherit'}
          fullWidth
          onClick={onClose}
        >
          {t('buttons.close')}
        </Button>

        {action}
      </DialogActions>
    </Dialog>
  );
}
